import { twMerge } from 'tailwind-merge';

export default function CarouselDot({
  className,
  onClick,
  selected,
}: {
  className?: string;
  onClick: () => void;
  selected: boolean;
}) {
  return (
    <button
      type="button"
      className={twMerge(
        className,
        'rounded-full bg-white opacity-70 h-2 w-2 mx-[2px] outline-hidden',
        selected && 'opacity-100 bg-primary'
      )}
      onClick={onClick}
      aria-label="Carousel dot button"
    />
  );
}
